import axios from 'axios';
import { SERVER_URL } from './constants.service';

export function getMailingProfiles() {
    return axios.get(`${SERVER_URL}/api/MailingProfiles`)
    .then(({ data }) => data);
}

export function createMailingProfile(profileData) {
    return axios.post(`${SERVER_URL}/api/MailingProfiles`, profileData)
    .then(({ data }) => data);
}

export function updateMailingProfile(id, profileData) {
    return axios.patch(`${SERVER_URL}/api/MailingProfiles/${id}`, profileData)
    .then(({ data }) => data);
}

export default { createMailingProfile, updateMailingProfile, getMailingProfiles };



// WEBPACK FOOTER //
// ./src/modules/services/mailing-profile.service.js